module.exports = __webpack_public_path__ + "img/Terms of Service3.13583cac.jpg";